<ms-my-bets-betslip-expand
    class="mybets-betslip-betbuilder"
    [myBetsListContext]="myBetsListContext()"
    [betslipId]="betslip().betslipId"
    [bets]="betslip().bets">
    @if (myBetsListContext().isPrintView) {
        <span>{{ sitecoreMyBets.myBets.BetSlipNr }}: {{ betslip().betslipId }}</span>
    }
    <ms-my-bets-betslip-card-title-options badges [betslip]="betslip()" [myBetsListContext]="myBetsListContext()" [isBetSlipBadgeVisible]="true" />
    <ng-container collapsed_view>
        <div class="mybets-betslip-multi-collapsed-view_options clearfix" (click)="eventClick()">
            @for (leg of bet().betBuilderInfo!.legs; track $index) {
                <span class="mybets-betslip-multi-collapsed-view_option-name highlight">{{ leg.name }}</span>
            }
        </div>
        <div class="mybets-betslip-betbuilder-collapsed-view_event_name" (click)="eventClick()">{{ bet().eventName }}</div>
        <div class="mybets-betslip-multi-collapsed-view_indicators" (click)="eventClick()">
            @for (legInfo of legsInfo(); track $index) {
                <ms-my-bets-multi-bet-card-indicator
                    [bet]="bet()"
                    [event]="bet().event"
                    [myBetsBetBuilderLeg]="legInfo"
                    [result]="legInfo.betState" />
            }
        </div>
    </ng-container>
    <div expanded_view class="mybets-betslip-betbuilder-expanded-view" (click)="eventClick()">
        <ms-my-bets-betbuilder-expanded-info
            [bet]="bet()"
            [event]="bet().event"
            [betSlipId]="betslip().betslipId"
            [myBetsListContext]="myBetsListContext()"
            [cancelledBet]="cancelledBet()"
            [cashedOut]="cashedOut()" />
        <div class="mybets-betslip-betbuilder-expanded-view_event_info">
            <ms-my-bets-betslip-scoreboard
                [bet]="bet()"
                [myBetsListContext]="myBetsListContext()"
                [cashedOut]="betslip().isCachedOut"
                [enableVisualization]="false">
                <ng-container default>
                    @if (bet(); as betValue) {
                        @if (betValue.event && betValue.event.live) {
                            <ms-my-bets-scoreboard-wrapper [event]="betValue.event" />
                        } @else {
                            <div class="mybets-betslip-betbuilder-expanded-view_event_name">{{ bet().eventName }}</div>
                            <div class="mybets-betslip-betbuilder-expanded-view_event-date font-small">
                                {{ bet().eventDate | msMyBetsEventDatePipe }}
                            </div>
                        }
                    }
                </ng-container>
            </ms-my-bets-betslip-scoreboard>
        </div>
    </div>

    @if (myBetsUtilService.isBetCardRedesigned()) {
        <ng-container mybets-expand-betslip-headsection>
            <ms-my-bets-bet-card-title
                [betslip]="betslip()"
                [myBetsListContext]="myBetsListContext()"
                [showEditButton]="true"
                [showOutcomeBadge]="true"
                [shouldApplyPaddings]="true">
                <ng-container title>
                    <div class="sgp-container">
                        @if (mybetsConfig.showBetTypeAsBadge) {
                            <ms-sgp-badge size="large" />
                        } @else {
                            <span class="mybets-betslip-multi-header_bet-type bold highlight">{{ sitecoreMyBets.myBets.BuildABet }}</span>
                        }
                        <span class="mybets-betslip-multi-header_pick-count combo-bet">
                            {{ bet().betBuilderInfo!.legs.length }} {{ sitecoreMyBets.myBets.Legs }}</span
                        >
                    </div>
                    @if (myBetsListContext().isPrintView) {
                        <span class="mybets-betslip-multi-header_print-betslip-id"
                            >{{ sitecoreMyBets?.myBets?.BetSlipNr }}: {{ betslip().betslipId }}</span
                        >
                    }
                </ng-container>
                <ng-container sub_title>
                    <div class="mybets-betslip-multi-collapsed-view_options clearfix" (click)="eventClick()">
                        @for (leg of bet().betBuilderInfo!.legs; track leg) {
                            <span class="mybets-betslip-multi-collapsed-view_option-name highlight">{{ leg.name }}</span>
                        }
                    </div>
                </ng-container>
            </ms-my-bets-bet-card-title>
        </ng-container>
    }

    <ng-container title>
        <span class="mybets-betslip-multi-header_bet-type bold highlight">{{ sitecoreMyBets.myBets.BuildABet }}</span>
        @if (isEpcotEnabled && !myBetsUtilService.isBetCardRedesigned()) {
            <span class="mybets-betslip-multi-header_pick-count"> {{ bet().betBuilderInfo!.legs.length }} {{ sitecoreMyBets.myBets.Legs }}</span>
        } @else {
            <span class="mybets-betslip-multi-header_pick-count"> {{ bet().betBuilderInfo!.legs.length }} {{ sitecoreMyBets.myBets.picks }}</span>
        }
        @if (myBetsListContext().isPrintView) {
            <span class="mybets-betslip-multi-header_print-betslip-id">{{ sitecoreMyBets?.myBets?.BetSlipNr }} : {{ betslip().betslipId }}</span>
        }
    </ng-container>
</ms-my-bets-betslip-expand>
